<template>
  <section id="donate" class="donate-section">
    <div class="donate-container">
      <h2>{{ $t('donate.title') }}</h2>
      <div class="donate-content">
        <div class="donate-info">
          <h3>Fonds des Amis Singing Molenbeek</h3>
          <p>{{ $t('donate.intro') }}</p>
          <div class="bank-details">
            <p><strong>{{ $t('donate.account') }}:</strong> BE10 0000 0000 0404</p>
            <p><strong>BIC:</strong> GEBABEBB</p>
            <p><strong>{{ $t('donate.holder') }}:</strong> Fondation Roi Baudouin</p>
            <p><strong>{{ $t('donate.communication') }}:</strong> +++ 623/4092/00067 +++</p>
          </div>
          <div class="tax-info">
            <p><em>{{ $t('donate.taxInfo') }}</em></p>
          </div>
          <div class="action-area">
            <a href="https://donate.kbs-frb.be/actions/FFO-ChanterPourVivreEnsemble?lang=fr_FR" target="_blank" rel="noopener noreferrer" class="donate-btn">
              {{ $t('donate.button') }}
            </a>
            <img src="@/assets/donation/foundation-roi-baudouin.svg" alt="Fondation Roi Baudouin" class="frb-logo" />
          </div>
        </div>
        <div class="qr-code-container">
          <img src="@/assets/donation/qr-code.png" alt="QR Code Donation" class="qr-code" />
          <p class="qr-text">{{ $t('donate.scan') }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
</script>

<style scoped>
.donate-section {
  padding: clamp(72px, 8vw, 108px) 20px;
  background: var(--warm-bg);
}

.donate-container {
  max-width: 1060px;
  margin: 0 auto;
}

.donate-content {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 280px;
  gap: clamp(32px, 5vw, 64px);
  align-items: center;
  padding: clamp(30px, 5vw, 56px);
  border: 1px solid rgba(38, 57, 77, 0.08);
  border-radius: var(--radius-lg);
  background: rgba(255, 255, 255, 0.94);
  box-shadow: var(--shadow-lg);
}

.donate-info {
  flex: 1;
}

.donate-info h3 {
  margin-bottom: 1.25rem;
  color: var(--primary-color);
  font-size: clamp(1.35rem, 2.2vw, 1.7rem);
  letter-spacing: -0.02em;
}

.bank-details {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 24px;
  margin: 1.75rem 0;
  padding: 22px;
  border-left: 4px solid var(--primary-color);
  border-radius: 0 var(--radius-sm) var(--radius-sm) 0;
  background: #faf7f3;
}

.bank-details p {
  margin: 0;
  color: var(--secondary-color);
  font-size: 0.96rem;
  font-variant-numeric: tabular-nums;
}

.bank-details strong {
  display: block;
  margin-bottom: 2px;
  color: var(--muted-color);
  font-size: 0.72rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.tax-info {
  font-size: 0.9rem;
  color: var(--muted-color);
  margin-bottom: 1.75rem;
  line-height: 1.5;
}

.action-area {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  flex-wrap: wrap;
}

.donate-btn {
  display: inline-flex;
  min-height: 48px;
  align-items: center;
  justify-content: center;
  background-color: var(--primary-color);
  color: white;
  padding: 0.8rem 2rem;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 750;
  transition: background-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
  box-shadow: 0 10px 24px rgba(201, 59, 69, 0.2);
}

.donate-btn:hover {
  background-color: var(--primary-dark);
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg, 0 10px 15px -3px rgba(0,0,0,0.1));
}

.frb-logo {
  height: 5.75rem;
  width: auto;
}

.qr-code-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 28px;
  border: 1px solid rgba(216, 169, 50, 0.35);
  border-radius: var(--radius);
  background: linear-gradient(145deg, #fff, #fdf8eb);
}

.qr-code {
  width: min(200px, 100%);
  aspect-ratio: 1;
  height: auto;
  object-fit: contain;
  margin-bottom: 1rem;
}

.qr-text {
  font-weight: 500;
  color: var(--secondary-color, #2c3e50);
  margin: 0;
}

@media (max-width: 768px) {
  .donate-section {
    padding: 3rem 1rem;
  }
  
  .donate-content {
    grid-template-columns: 1fr;
    padding: 1.5rem;
    gap: 2rem;
  }

  .bank-details {
    grid-template-columns: 1fr;
  }
  
  .action-area {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  
  .frb-logo {
    height: 6rem;
  }
  
  .qr-code {
    width: 150px;
    height: 150px;
  }
}
</style>
